import { render, staticRenderFns } from "./CreateConversationModal.vue?vue&type=template&id=c742c976"
import script from "./CreateConversationModal.vue?vue&type=script&lang=ts"
export * from "./CreateConversationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c742c976')) {
      api.createRecord('c742c976', component.options)
    } else {
      api.reload('c742c976', component.options)
    }
    module.hot.accept("./CreateConversationModal.vue?vue&type=template&id=c742c976", function () {
      api.rerender('c742c976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/CreateConversationModal.vue"
export default component.exports